import { Report } from 'features/reporting/types'

import { AssetCorrosionAnalysisSection } from './sections/AssetCorrosionAnalysis'
import { BundleSubInspectionsSection } from './sections/BundleSubInspections'
import { ChecklistFindingsSection } from './sections/ChecklistFindings'
import { CoverSection } from './sections/Cover'
import { FindingsSection } from './sections/Findings'
import { InspectionTeamSection } from './sections/InspectionTeam'
import { PDFGeneration } from './sections/PDFGeneration'
import { PressureTestSubInspectionsSection } from './sections/PressureTestSubInspections'
import { RecommendationsSection } from './sections/Recommendations'
import { ReferenceDocumentsSection } from './sections/ReferenceDocuments'
import { ReferenceImagesSection } from './sections/ReferenceImages'
import { ReportReview } from './sections/ReportReview'

export const visualReportForSPA: Report = {
  coverSection: CoverSection,
  tocSection: {
    id: 'toc',
    title: 'Table of Contents',
    RenderPDF: () => null, // TODO: Implement TOC PDF component
  },
  sections: [
    ChecklistFindingsSection,
    AssetCorrosionAnalysisSection,
    FindingsSection,
    RecommendationsSection,
    PressureTestSubInspectionsSection,
    BundleSubInspectionsSection,
    InspectionTeamSection,
    ReferenceDocumentsSection,
    ReferenceImagesSection,
  ],
  reviewSection: ReportReview,
  pdfGenerationSection: PDFGeneration,
  staticSections: [],
}
